import { filterTypes } from '@/constants/Srp'
import { formatCurrency } from '@/utils'
import { Container, Typography } from '@cleartrip/ct-design-components'
import { useEffect, useState } from 'react'
import InputRange from 'react-input-range-rtl'
import FilterJourneyInfo from './FilterJourneyInfo'
import RangeSlider from './RangeSlider'

const PriceFilter = (props: any) => {
  const {
    currentPrice,
    minPrice,
    maxPrice,
    onFilterChange,
    isPerAdult = true,
    from,
    to,
    isRT,
    isRevamp = false,
  } = props

  const [price, setPrice] = useState<any>(currentPrice)
  const [step, setStep] = useState(100)

  useEffect(() => {
    if (currentPrice !== price) setPrice(currentPrice)
  }, [currentPrice])

  const onValueChange = (value: any) => {
    setPrice(value)

    const diffPriceFromMax = value - maxPrice
    if (diffPriceFromMax < 100 && step > 99) {
      setStep(1)
    }
  }

  const onValueChangeComplete = (value: any) => {
    onFilterChange(filterTypes.ONE_WAY_PRICE, value)
  }

  return (
    <>
      <FilterJourneyInfo from={from} to={to} isRT={isRT} isRevamp={isRevamp} legacyClassName='c-pointer my-3' />
      {isRevamp ? (
        <Container className='flex flex-column'>
          <Container className='flex pb-3'>
            <Typography
              variant='P2'
              className='fs-caption-2 c-neutral-400 mr-2'
            >{`${formatCurrency(minPrice)} - ${formatCurrency(price)}`}</Typography>
          </Container>
          <RangeSlider
            ariaLabel='Flight price'
            max={maxPrice}
            min={minPrice}
            value={price}
            onChange={onValueChange}
            onChangeComplete={onValueChangeComplete}
          />
        </Container>
      ) : (
        <Container className='pl-1 pb-6 intl_inputRange' style={{ width: '90%' }}>
          <Container className='flex pt-4 pb-3 '>
            <Typography
              variant='L2'
              className='fs-caption-2 c-neutral-400 mr-2'
            >{`${formatCurrency(minPrice)} - ${formatCurrency(price)}`}</Typography>
          </Container>
          <InputRange
            minValue={minPrice}
            maxValue={maxPrice}
            value={price}
            onChange={onValueChange}
            onChangeComplete={onValueChangeComplete}
            step={step}
          />
        </Container>
      )}
    </>
  )
}
export default PriceFilter
